<template>
    <div class="app-date-range-manual" :class="{ center }">
        <div class="date-ranges">
            <div class="date-item">
                <date-input
                    v-model="newValue"
                    :typeable="true"
                    icon="calendar_new"
                    manual
                    :disabled-dates="disabledDates"
                    @input="onInput"
                />
            </div>
        </div>

        <div
            v-if="
                !hideRangeText &&
                    newValue &&
                    dateLengthText.toString() !== 'משך הביטוח: NaN ימים'
            "
            class="insurance-date-text"
            v-html="dateLengthText"
        ></div>
    </div>
</template>

<script>
import { he } from "vuejs-datepicker/dist/locale";
import DateInput from "../Forms/DateInput";

import moment from "moment";
import MaskedInput from "vue-masked-input";

export default {
    name: "app-input",
    components: {
        DateInput
    },
    props: {
        type: {
            type: String,
            default: "text"
        },
        disabledDates: Object,
        value: [String, Number, Date],
        endDate: moment,
        lengthText: String,
        placeholder: String,
        error: Boolean,
        message: String,
        autofocus: Boolean,
        center: Boolean,
        hideRangeText: Boolean,
        typeable: Boolean,
        loading: false,
        disabled: false
    },

    data() {
        return {
            newValue: this.value,
            he: he
        };
    },

    watch: {
        value() {
            this.newValue = this.value;
        }
    },

    methods: {
        onInput(e) {
            this.$emit("input", e);
            this.$emit("change", e);
        }
    },

    computed: {
        filled() {
            return this.newValue || this.focused;
        },
        dateLengthText() {
            const length = this.lengthText;

            const startDate = moment(this.newValue);
            const endDate = this.endDate;

            return length.replace(
                /\$/,
                endDate.diff(
                    startDate.set({
                        hour: 0,
                        minute: 0,
                        second: 0,
                        millisecond: 0
                    }),
                    "days"
                ) + 1
            );
        },
        endDateText() {
            return this.endDate.format("D/MM/yyyy");
        }
    }
};
</script>

<style lang="scss">
.app-date-range-manual {
    &.center {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .date-ranges {
        width: 100%;
        border-radius: 100px;
        border: 1px solid #c6c6c6;
        background: $lightest-gray;

        .separator {
            font-size: 20px;
            font-weight: bold;
            line-height: 1.3;
            color: $black;
            margin: 0 20px;
        }

        .date-item {
            font-size: 20px;
            font-weight: bold;
            line-height: 1.3;
            color: $black;

            .vdp-datepicker {
                position: relative;
                border-bottom: 1px solid $black;

                &:after {
                    content: "";
                    position: absolute;
                    width: 18px;
                    height: 18px;
                    left: 0;
                    top: 50%;
                    transform: translateY(-50%);
                    background-image: url("../../../images/icons/calendar.svg");
                }

                input {
                    border: none;
                    font-size: 20px;
                    font-weight: bold;
                    line-height: 1.3;
                    color: $black;
                    outline: none;
                    width: 130px;

                    &:hover,
                    &:active,
                    &:focus {
                        border: none;
                    }
                }
            }
        }
    }

    .insurance-date-text {
        margin-top: 15px;
        font-size: 20px;
        font-weight: $font-light;
        line-height: 1.3;
        color: $black;
    }
}
</style>
